import { render, staticRenderFns } from "./AccessPointProfile.vue?vue&type=template&id=820dbfc8&scoped=true&lang=pug&"
import script from "./AccessPointProfile.vue?vue&type=script&lang=ts&"
export * from "./AccessPointProfile.vue?vue&type=script&lang=ts&"
import style0 from "./AccessPointProfile.vue?vue&type=style&index=0&id=820dbfc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820dbfc8",
  null
  
)

export default component.exports